import Cookies from "js-cookie";
import { TOKEN_KEY } from "@/constants/auth";

export const getToken = () => Cookies.get(TOKEN_KEY);

export const setToken = (token) =>
	Cookies.set(TOKEN_KEY, token, { expires: 7, path: "/" });

export const removeToken = () => Cookies.remove(TOKEN_KEY);
